import { registerBlockType } from "@wordpress/blocks";
import { select, dispatch, useSelect } from "@wordpress/data";
const { omit } = lodash;

export {
    generateBackgroundControlStyles,
    generateBackgroundAttributes,
} from "./backgroundHelpers";

export {
    generateTypographyAttributes,
    generateTypographyStyles,
} from "./typoHelpers";

export {
    generateDimensionsAttributes,
    generateDimensionsControlStyles,
} from "./dimensionHelpers";

export {
    generateBorderShadowAttributes,
    generateBorderShadowStyles,
} from "./borderShadowHelpers";

export {
    generateResponsiveRangeStyles,
    generateResponsiveRangeAttributes,
} from "./responsiveRangeHelpers";

export {
    generateResponsiveSelectControlAttributes,
    generateResponsiveSelectControlStyles,
} from "./responsiveSelectControlHelpers";

export {
    generateResponsiveAlignAttributes,
    generateResponsiveAlignStyles,
} from "./responsiveAlignControlHelpers";

export {
    textInsideForEdit,
    generateRandomNumber,
    hardMinifyCssStrings,
    softMinifyCssStrings,
    isCssExists,
    ucFirst,
} from "./miniHelperFuncs";

export {
    handleDesktopBtnClick,
    handleTabBtnClick,
    handleMobileBtnClick,
} from "./handlingPreviewBtnsHelpers";

export {
    mimmikCssForResBtns,
    mimmikCssForPreviewBtnClick,
    mimmikCssOnPreviewBtnClickWhileBlockSelected,
    duplicateBlockIdFix,
} from "./funcsForUseEffect";

export { ebImageSizes, EbImageSizeSelector } from "./coreSettings";

export { stripHtmlTags, isValidHtml } from "./stripFunc";

export { getFlipTransform, getButtonClasses } from "./flipboxHelpers";

export { StyleComponent } from "./StyleComponent";

export {
    generateShapeDividerStyles,
    generateShapeDividerAttributes,
} from "./shapeDividerHelpers";

export {
    fetchOptionsData,
    saveOptionsData,
    fetchEBSettingsData,
    saveEBSettingsData,
    fetchFormBlockData,
    saveFormBlockData,
    installPlugin,
} from "./apiFetch";

export { ShapeDividerContent } from "./shapeDividerContent";
export { ShapeDividerList } from "./shapeDividerList";

//Check if the string is JSON or plain String
export const ebJsonStringCheck = (string) => {
    try {
        var o = JSON.parse(string);
        if (o && typeof o === "object") {
            return true;
        }
    } catch (e) {}

    return false;
};

/**
 * String to Component Name
 * @param {*} string
 */
export const ebStringToComponentName = (str) => {
    const arr = str.split("_");
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    return arr.join("");
};

/**
 * filter blocks clientID by name
 * @param {array} blocks
 * @param {string} name
 * @returns {array}
 */
export const filterBlocksByName = (blocks, name) => {
    let filteredBlocks = [];

    function extractIds(blocks, name) {
        if (blocks && blocks.length > 0) {
            blocks.map((block) => {
                if (block.name && block.name === name) {
                    filteredBlocks.push(block.clientId);
                }
                if (block.innerBlocks && block.innerBlocks.length > 0) {
                    extractIds(block.innerBlocks, name);
                }
            });
        }
    }
    extractIds(blocks, name);

    return filteredBlocks;
};

/**
 * get blocks parent block ClientId by name
 * @param {string} blocks
 * @param {string} name
 * @returns {string}
 */
export const getBlockParentClientId = (clientId, parent_block_name) => {
    let parentId = false;
    const parentIds = select("core/block-editor").getBlockParents(clientId);
    if (typeof parentIds === "object" && parentIds.length > 0) {
        parentId = parentIds.filter(
            (id) =>
                parent_block_name ===
                select("core/block-editor").getBlockName(id)
        );
        if (typeof parentId === "object" && parentId.length > 0) {
            parentId = parentId[0];
        }
    }
    return parentId;
};

/**
 * Conditional Register Block
 */
export const ebConditionalRegisterBlockType = (metadata, settings) => {
    const { name } = metadata;
    const { eb_wp_version, all_blocks } = EssentialBlocksLocalize;

    //Generate Block key from block full name
    const regex = /^essential-blocks\//;
    if (regex.test(name)) {
        let block_key = name.replace(
            /essential-blocks\/pro-|essential-blocks\/|-/g,
            "_"
        );
        if (block_key.charAt(0) === "_") {
            block_key = block_key.substring(1);
        }

        //If block visibility false, don't register
        if (
            all_blocks[block_key] &&
            all_blocks[block_key]?.visibility === "false"
        ) {
            return false;
        }
    }

    if (eb_wp_version >= 5.8) {
        registerBlockType({ name, ...metadata }, settings);
    } else {
        registerBlockType(`${name}`, {
            ...omit(metadata, ["name"]),
            ...settings,
        });
    }
};

/**
 * Check if the given color is gradient or not
 * @param {*} color
 * @returns {boolean}
 */
export const isGradientColor = (color) => {
    if (color.includes("gradient")) {
        return true
    }
    // Regular expression to check for common gradient keywords
    const gradientRegex = /(linear|radial)-gradient|conic-gradient/;

    // Use the test method to check if the color contains a gradient keyword
    return gradientRegex.test(color);
}
